import { render, staticRenderFns } from "./FranchiseData.vue?vue&type=template&id=4d864b10&scoped=true&"
import script from "./FranchiseData.vue?vue&type=script&lang=js&"
export * from "./FranchiseData.vue?vue&type=script&lang=js&"
import style0 from "./FranchiseData.vue?vue&type=style&index=0&id=4d864b10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d864b10",
  null
  
)

export default component.exports